import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import "./style.scss";

export const GlobalSearchResult = ({ item, isFaculty }) => {
    return (
        <Container className={`global-search-result`}>
        { !isFaculty ? (
            <div className={"program"}>
                <Row className="justify-content-between">
                    <a role="h3" href={`/${item.langcode}/node/${item.nid}`} name="program-title">{ item.title }</a>
                    <p className="single-double-major field-program">{ item.field_mamta_programs[0]?.field_learning_aspect_name }</p>
                </Row>
                <Row>
                    <p>{ Utils.removeTags(item.field_short_description) }</p>
                    {item.body&& <p>{Utils.removeTags(item?.body)}</p>}
                </Row>
            </div>
        ) : (
                <div className={"faculty"}>
                <Row className="justify-content-between">
                    <ul name="program-title">{ item }</ul>
                </Row>
            </div>
        )}
        </Container>
    );
}